<template>
  <div class="editor-container-readonly">
    <div class="toolbar-wrapper">
      <div ref="toolbarRef" class="toolbar" style="display: none"></div>
    </div>
    <div ref="editorRef" class="editor-content"
         :style="{border: 'none',height: minHeight}"></div>
  </div>
</template>

<script>
import E from 'wangeditor';

export default {
  name: 'CustomEditorReadonly',
  props: {
    value: {
      type: String,
      default: ''
    },
    minHeight: {
      type: String,
      default: '300px'
    }
  },
  data() {
    return {
      editor: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initEditor();
    });
  },
  watch: {
    value(newVal) {
      if (this.editor && newVal !== this.editor.txt.html()) {
        this.editor.txt.html(newVal);
      }
    }
  },
  methods: {
    initEditor() {
      this.editor = new E(this.$refs.toolbarRef, this.$refs.editorRef);

      // 配置编辑器
      this.editor.config.onchange = (newHtml) => {
        this.$emit('input', newHtml);
      };

      // 自定义配置以解决遮挡问题
      this.editor.config.zIndex = 100;

      // 初始化编辑器
      this.editor.create();
      this.editor.disable();
      // 设置初始内容
      if (this.value) {
        this.editor.txt.html(this.value);
      }
    },
  }
};
</script>

<style scoped lang="scss">


.editor-container-readonly {
  position: relative;
  width: 100%;
  padding: 10px;

  .toolbar-wrapper {
    position: relative;
    z-index: 99999;
  }

  .toolbar {
    border: 1px solid #ccc;
    background-color: white;
  }

  .editor-content {
    width: 100%;
    border: 1px solid #ccc;
    border-top: none;
    margin-bottom: 10px;
    word-break: break-all;
  }

  .w-e-menu {
    position: relative !important;
  }

  .w-e-droplist {
    z-index: 200 !important;
  }
}

</style>
